import {SvgIconData} from '@shared_web/components/core/svg_icon';

export const icon_triangle_fill: SvgIconData = {
  viewBox: '1.47363 2.4999990414770243 21.052745237824013 18.500200958522974',
  element: (
    <path d="M12.8659 3.00017L22.3922 19.5002C22.6684 19.9785 22.5045 20.5901 22.0262 20.8662C21.8742 20.954 21.7017 21.0002 21.5262 21.0002H2.47363C1.92135 21.0002 1.47363 20.5525 1.47363 20.0002C1.47363 19.8246 1.51984 19.6522 1.60761 19.5002L11.1339 3.00017C11.41 2.52187 12.0216 2.358 12.4999 2.63414C12.6519 2.72191 12.7782 2.84815 12.8659 3.00017Z" />
  ),
};
